import { call, put, takeEvery, select } from "redux-saga/effects";

// Login Redux States
//Include Both Helper File with needed methods
import {
  setMetaAdPlatforms,
  setMetaCountries,
  setTrackerPlatforms,
} from "./actions";
import {
  META_GET_COUNTRIES,
  GET_META_TRACKER_PLATFORMS,
  GET_META_AD_PLATFORMS,
} from "./actionTypes";
import {
  getMetaAdPlatforms,
  getMetaCountries,
  getTrackingPlatforms,
} from "../../helpers/jwt_helper";
import { getErrorMessage, showErrorMessage } from "../../helpers/utils";

function* onGetMetaCountries() {
  try {
    const countries = yield select(state => state.Meta.countries)
    if (countries?.length > 0) return void 0;

    let response = yield call(getMetaCountries);
    response = Object.keys(response).map(key => ({
      value: key,
      label: response[key],
    }));
    yield put(setMetaCountries(response));
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetTrackingPlatforms() {
  try {
    let response = yield call(getTrackingPlatforms);
    let dt = {
      tracking_platform: [],
    };
    if (response?.tracking_platform.length > 0) {
      dt = {
        tracking_platform: ['None', 'REPORT', ...response.tracking_platform]
      }
    }
    yield put(setTrackerPlatforms(dt));
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetMetaAdPlatforms() {
  try {
    let response = yield call(getMetaAdPlatforms);
    yield put(setMetaAdPlatforms(response.ad_platform));
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* metaSaga() {
  yield takeEvery(META_GET_COUNTRIES, onGetMetaCountries);
  yield takeEvery(GET_META_TRACKER_PLATFORMS, onGetTrackingPlatforms);
  yield takeEvery(GET_META_AD_PLATFORMS, onGetMetaAdPlatforms);
}

export default metaSaga;
